import antdTH from "antd/lib/locale-provider/th_TH";
import { flattenMessages } from "lng-provider";
import thMessages from "../locales/th-TH.json";
import constThMessages from "../locales/const-TH.json";

const thLang = {
  messages: {
    ...flattenMessages(thMessages),
    ...flattenMessages(constThMessages),
  },
  antd: antdTH,
  locale: 'th-TH'
}

export default thLang;
